import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';
import { Button } from './ui/button';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isEquipmentOpen, setIsEquipmentOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Início', href: '/' },
    { name: 'Vendas', href: '/sales' },
    { name: 'Locação', href: '/rental' },
    { name: 'Manutenção', href: '/maintenance' },
    { name: 'Sobre Nós', href: '/about' },
    { name: 'Blog', href: '/blog' },
    { name: 'Contato', href: '/contact' }
  ];

  const equipmentLinks = [
    { name: 'Todos os Equipamentos', href: '/equipment' },
    { name: 'Raio-X', href: '/raio-x' },
    { name: 'Tomografia', href: '/tomografia' },
    { name: 'Ressonância Magnética', href: '/ressonancia' },
    { name: 'Ultrassom', href: '/ultrassom' },
    { name: 'Densitometria Óssea', href: '/densitometria' },
    { name: 'Mamografia', href: '/mamografia' },
    { name: 'CR (Radiografia Computadorizada)', href: '/cr' },
    { name: 'DR (Radiografia Digital)', href: '/dr' },
    { name: 'Workstation', href: '/workstation' },
    { name: 'PACS', href: '/pacs' },
  ];

  const isActive = (href) => location.pathname === href;
  const isEquipmentActive = () => 
    location.pathname === '/equipment' || 
    location.pathname === '/raio-x' || 
    location.pathname === '/tomografia' ||
    location.pathname === '/ressonancia' ||
    location.pathname === '/ultrassom' ||
    location.pathname === '/densitometria' ||
    location.pathname === '/mamografia' ||
    location.pathname === '/cr' ||
    location.pathname === '/dr' ||
    location.pathname === '/workstation' ||
    location.pathname === '/pacs';

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-gray-200">
      <nav className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          <Link to="/" className="flex items-center space-x-2">
            <img 
              src="/visiomed-logo.jpeg" 
              alt="Visiomed Eletromedicina" 
              className="h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex md:items-center md:space-x-6">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors hover:text-blue-600 ${
                isActive('/') ? 'text-blue-600' : 'text-gray-700'
              }`}
            >
              Início
            </Link>

            {/* Equipment Dropdown */}
            <div 
              className="relative group"
              onMouseEnter={() => setIsEquipmentOpen(true)}
              onMouseLeave={() => setIsEquipmentOpen(false)}
            >
              <button
                className={`text-sm font-medium transition-colors hover:text-blue-600 flex items-center py-4 ${
                  isEquipmentActive() ? 'text-blue-600' : 'text-gray-700'
                }`}
                onClick={() => setIsEquipmentOpen(!isEquipmentOpen)}
              >
                Equipamentos
                <ChevronDown size={16} className={`ml-1 transition-transform ${isEquipmentOpen ? 'rotate-180' : ''}`} />
              </button>
              
              {isEquipmentOpen && (
                <div className="absolute top-full left-0 pt-0 w-64 z-50">
                  <div className="bg-white rounded-lg shadow-lg border py-2">
                    {equipmentLinks.map((item) => (
                      <Link
                        key={item.name}
                        to={item.href}
                        className={`block px-4 py-2.5 text-sm transition-colors ${
                          isActive(item.href) 
                            ? 'text-blue-600 bg-blue-50' 
                            : 'text-gray-700 hover:text-blue-600 hover:bg-gray-50'
                        }`}
                        onClick={() => setIsEquipmentOpen(false)}
                      >
                        {item.name}
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {navigation.slice(1).map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`text-sm font-medium transition-colors hover:text-blue-600 ${
                  isActive(item.href) ? 'text-blue-600' : 'text-gray-700'
                }`}
              >
                {item.name}
              </Link>
            ))}
            <Link to="/contact">
              <Button className="bg-blue-600 hover:bg-blue-700 text-white">
                Solicitar Orçamento
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 text-gray-700"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 space-y-4">
            <Link
              to="/"
              className={`block text-sm font-medium transition-colors hover:text-blue-600 ${
                isActive('/') ? 'text-blue-600' : 'text-gray-700'
              }`}
              onClick={() => setIsMenuOpen(false)}
            >
              Início
            </Link>
            
            {/* Mobile Equipment Submenu */}
            <div className="space-y-2">
              <span className="block text-sm font-semibold text-gray-900">Equipamentos</span>
              <div className="ml-4 space-y-2">
                {equipmentLinks.map((item) => (
                  <Link
                    key={item.name}
                    to={item.href}
                    className={`block text-sm transition-colors hover:text-blue-600 ${
                      isActive(item.href) ? 'text-blue-600' : 'text-gray-600'
                    }`}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {item.name}
                  </Link>
                ))}
              </div>
            </div>

            {navigation.slice(1).map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`block text-sm font-medium transition-colors hover:text-blue-600 ${
                  isActive(item.href) ? 'text-blue-600' : 'text-gray-700'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                {item.name}
              </Link>
            ))}
            <Link to="/contact" onClick={() => setIsMenuOpen(false)}>
              <Button className="w-full bg-blue-600 hover:bg-blue-700 text-white">
                Solicitar Orçamento
              </Button>
            </Link>
          </div>
        )}
      </nav>
    </header>
  );
};
